module.exports = __webpack_public_path__ + "static/media/hamburger.86595150.svg";